import { useSettings } from "@/context/SettingsContext";
import { resolveImg } from "@/lib/api";

export const Logo = ({ height = 48, className = "", onClick }) => {
  const settings = useSettings();
  return (
    <img
      src={resolveImg(settings.logo_url)}
      alt="Klusbedrijf Pruijn"
      style={{ height: `${height}px` }}
      className={`w-auto object-contain select-none ${className}`}
      onClick={onClick}
      data-testid="brand-logo"
      draggable={false}
    />
  );
};

export default Logo;
